import { Component } from '@angular/core';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';

@Component({
  selector: 'piqet-angular-grid-cell-info',
  templateUrl: './grid-cell-info.component.html',
  styleUrls: ['./grid-cell-info.component.scss'],
})
export class GridCellInfoComponent {
  params: any;
  materialname: any;
  materialInfoDataKey: any;
  materialInfoData: any;
  materialInfoDataValues: any;
  processId: any;
  countryId: any;
  customConversionProcessId: any;

  constructor(private projectsService: ProjectsService) {}

  agInit(params: any): void {
    this.params = params;
  }

  async getIngrientInfo() {
    let tooltipData = await this.projectsService.GetConversionProcessInfo(
      !!this.params.data.conversionProcessId ? this.params.data.conversionProcessId : 0,
      !!this.params.data.conversionCountryId ? this.params.data.conversionCountryId : 0,
      !!this.params.data.customConversionId ? this.params.data.customConversionId : 0,
      true
    );
    this.materialInfoData = tooltipData.data;
    this.materialInfoDataKey = Object.keys(this.materialInfoData);
    this.materialInfoDataValues = Object.values(this.materialInfoData);
    this.materialname = this.materialInfoData.name;
  }

  toTitleCase(str: any) {
    return str.replace(/\w\S*/g, (txt: any) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
}
